import React, {Component} from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-solid';

class Education extends Component {
  render() {
    return (
      <div>
        <h3 className="uk-text-uppercase uk-text-bold">Education</h3>
        <div className="uk-animation-slide-top-small">
          <div className="uk-padding-small">
            <div uk-grid="true">
              <div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                <div uk-grid="true">
                  <div className="uk-width-expand uk-width-expand@s uk-width-expand@l uk-width-expand@m uk-width-expand@xl uk-text-right">
                    <p className="uk-margin-remove-vertical"><strong>High School</strong></p>
                    <p className="uk-margin-remove-vertical">Fatima High School</p>
                  </div>
                  <div className="uk-width-1-4 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-4@s"><FontAwesomeIcon className="fa-4x color-biscuit" icon="building"/>
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                <div uk-grid="true">
                  <div className="uk-width-1-4 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-4@s"><FontAwesomeIcon className="fa-4x color-biscuit" icon="building"/>
                  </div>
                  <div className="uk-width-expand uk-width-expand@s uk-width-expand@l uk-width-expand@m uk-width-expand@xl uk-text-left">
                    <p className="uk-margin-remove-vertical"><strong>Diploma in Computer Engineering</strong></p>
                    <p className="uk-margin-remove-vertical">State Board of technical education</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div className="uk-padding-small uk-padding-remove-horizontal">
            <div uk-grid="true">
              <div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                <div uk-grid="true">
                  <div className="uk-width-expand uk-width-expand@s uk-width-expand@l uk-width-expand@m uk-width-expand@xl uk-text-right">
                    <p className="uk-margin-remove-vertical"><strong>Web Designing</strong></p>
                    <p className="uk-margin-remove-vertical">Arena Animation</p>
                  </div>
                  <div className="uk-width-1-4 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-4@s"><FontAwesomeIcon className="fa-4x color-blue" icon="certificate"/>
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                <div uk-grid="true">
                  <div className="uk-width-1-4 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-4@s"><FontAwesomeIcon className="fa-4x color-blue" icon="certificate"/>
                  </div>
                  <div className="uk-width-expand uk-width-expand@s uk-width-expand@l uk-width-expand@m uk-width-expand@x uk-text-left">
                    <p className="uk-margin-remove-vertical"><strong>Computer Hardware Engineer</strong></p>
                    <p className="uk-margin-remove-vertical">Micheal Technologies</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div className="uk-padding-small uk-padding-remove-horizontal">
            <div className="uk-text-center">
              <FontAwesomeIcon className="fa-4x color-black" icon="graduation-cap"/>
              <p className="uk-margin-remove-vertical"><strong>Bachelors in Computer Science Engineering</strong></p>
              <p className="uk-margin-remove-vertical">MallaReddy Engineering College</p>
            </div>
            {/*<div uk-grid="true">*/}
            {/*<div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">*/}
            {/*<div uk-grid="true">*/}
            {/*<div className="uk-width-expand uk-width-expand@s uk-width-expand@l uk-width-expand@m uk-width-expand@x uk-text-right">*/}
            {/*<p className="uk-margin-remove-vertical"><strong>Bachelors in Computer Science Engineering</strong></p>*/}
            {/*<p className="uk-margin-remove-vertical">MallaReddy Engineering College</p>*/}
            {/*</div>*/}
            {/*<div className="uk-width-1-4 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-4@s"><FontAwesomeIcon className="fa-4x color-black" icon="graduation-cap"/></div>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*<div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">*/}
            {/*<div uk-grid="true">*/}
            {/*<div className="uk-width-1-4 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-4@s"><FontAwesomeIcon className="fa-4x color-black" icon="graduation-cap"/></div>*/}
            {/*<div className="uk-width-expand uk-width-expand@s uk-width-expand@l uk-width-expand@m uk-width-expand@x uk-text-left">*/}
            {/*<p className="uk-margin-remove-vertical"><strong>Master of Science in Computer Science</strong></p>*/}
            {/*<p className="uk-margin-remove-vertical">Northwestern Polytechnic University</p>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*</div>*/}
          </div>
          <hr/>
          <div className="uk-text-center">
            <p><strong>Achievements</strong></p>
            <p className="uk-margin-remove-bottom">1'st in Web Template Designing in diploma</p>
            <p className="uk-margin-remove-vertical"> 1'st in Googling in Bachelors Degree</p>
            <p className="uk-margin-remove-top">Organised Web Designing event for the fest in Bachelors Degree</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Education;


// WEBPACK FOOTER //
// src/components/Education.js